<script>

    import { link } from 'svelte-spa-router'

    export let size = ''
    export let selected = ''
    export let options = []

</script>

<div class="tabs is-{size}">
    <ul>
        {#each options as option}
            <li on:click={() => selected = option.value} class:is-active={selected === option.value}>
                {#if option.href}
                    <a href="{ option.href }" use:link >
                        {#if option.icon}
                            <span class="icon"><i class="fas fa-{option.icon}"></i></span>
                        {/if}
                        {#if option.text}
                            <span>{option.text}</span>
                        {/if}
                    </a>
                {:else}
                    <a>
                        {#if option.icon}
                            <span class="icon"><i class="fas fa-{option.icon}"></i></span>
                        {/if}
                        {#if option.text}
                            <span>{option.text}</span>
                        {/if}
                    </a>
                {/if}
                    
            </li>
        {/each}
    </ul>
</div>